<template>
	<AsiDialogFormLayout max-width="84rem" :icon="icons.frameAssembly" :title="$t('frameAssembly.singular')"
	                     :open="open" :loading="loading" :valid="true" :errors="errors"
	                     @save="requestSave" :save-disabled="getSaveButtonDisabled" @cancel="cancel" unwrapped scrollable>
		<v-card-text class="pa-6 grey lighten-5">
			<FrameAssemblyConfigurator v-model="updateModel" @position-nr-validation="onPositionNrValidation"/>
		</v-card-text>
	</AsiDialogFormLayout>
</template>

<script lang="ts">
	import {Component, Emit, Prop, Watch} from "vue-property-decorator";
	import AsiLocaleAutocompleteInput from "@/components/common/AsiLocaleAutocompleteInput.vue";
	import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
	import AsiTextField from "@/components/common/AsiTextField";
	import FrameAssemblyConfigurator from "@/components/frame-assembly/FrameAssemblyConfigurator.vue";
	import FrameAssemblyUpdate from "@/models/frame-assembly/FrameAssemblyUpdate";
	import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
	import {
		IFrameAssemblyConfiguration, IFrameAssemblyConfigurationGroup,
	} from "@/models/frame-assembly/FrameAssemblyModels";

	@Component({
		components: {FrameAssemblyConfigurator, AsiTextField, AsiDialogFormLayout, AsiLocaleAutocompleteInput}
	})
	export default class FrameAssemblyUpdateDialog extends AsiDialogForm {

		private isPositionNrValid: boolean = true;

		@Prop({type: Object, required: true})
		public frameAssemblyConfiguration!: IFrameAssemblyConfiguration;

		@Prop({type: Object, required: true})
		public frameAssemblyConfigurationGroup!: IFrameAssemblyConfigurationGroup;

		@Prop({type: String, required: true})
		public positionId!: string;

		@Prop({type: String, required: true})
		public cartId!: string;

		@Watch('frameAssemblyConfiguration', {deep: true, immediate: true})
		private onValueChanged(): void {
			this.updateModel = new FrameAssemblyUpdate(this.frameAssemblyConfiguration, this.frameAssemblyConfigurationGroup.frameType);
		}

		private updateModel: FrameAssemblyUpdate | null = null;

		private requestSave(): void {
			if (this.updateModel === null) return;

			this.$cartServiceShop.updateFrameAssemblyConfiguration(this.cartId,
				this.positionId, this.frameAssemblyConfigurationGroup.id,
				this.frameAssemblyConfiguration.id, this.updateModel)
				.then(this.save)
				.catch(this.handleErrors)
				.finally(() => this.loading = false);
		}

		@Emit('save')
		public save(): void {
			return;
		}

		@Emit('cancel')
		public cancel(event: Event): Event {
			this.updateModel?.reset();
			return event;
		}

		private onPositionNrValidation(isValid: boolean){
			this.isPositionNrValid = isValid;
		}

		private get getSaveButtonDisabled(): boolean {
			return !this.isPositionNrValid;
		}
	}
</script>

<style lang="scss" scoped>

</style>
